import { createContext, useContext, useState, useCallback } from 'react';
import api from './api';

const AuthContext = createContext(null);

function readUser() {
  try {
    return localStorage.getItem('palet_token') ? JSON.parse(localStorage.getItem('palet_user')) : null;
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(readUser);

  const login = useCallback(async (username, password) => {
    const params = new URLSearchParams({ username, password });
    const { data } = await api.post('/auth/login', params, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    localStorage.setItem('palet_token', data.access_token);
    localStorage.setItem('palet_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('palet_token');
    localStorage.removeItem('palet_user');
    setUser(null);
  }, []);

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
export const isAdmin = (user) => ['admin', 'super_admin'].includes(user?.role);
